import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {AnimationsManagerService} from '../../../../../Services/Platform/Ionic/animations-manager.service';
import {YuDatetimeModal} from '../../../../Controls/yu-datetime/yu-datetime.component';
import {YuColorDto} from 'yukit';

@Component({
  selector: 'app-data-block',
  templateUrl: './data-block.component.html',
  styleUrls: ['./data-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DataBlockComponent {

  @Input() reference!: string;
  @Input() date!: string;
  @Input() local!: string;
  @Input() provider!: string;
  @Input() state!: string;
  @Input() colorState!: YuColorDto;

  @Input() canDateChange: boolean = false;
  @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    protected modalCtrl: ModalController,
    protected animationCtrl: AnimationsManagerService,
  ) {
  }


  /**
   * Abrir vista modal para seleccionar la fecha
   *
   */
  async openModalDate() {

    if (!this.canDateChange) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: YuDatetimeModal,
      enterAnimation: this.animationCtrl.showModalAnimation,
      leaveAnimation: this.animationCtrl.hideModalAnimation,
      componentProps: {
        dateValue: this.date,
        inputOutputFormat: "yyyy-MM-dd'T'HH:mm:ssxxx",
      },
      cssClass: 'transparent-modal',
    });

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.date = data.data;
        this.dateChange.emit(data.data);
      }
    });

    await modal.present();
  }

}
